"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessManagerSubject = exports.NotificationPlanSubject = exports.NotificationSubject = exports.ZoneTypeSubject = exports.ZoneSubject = exports.UserSubject = exports.TeamSubject = exports.StatisticsSubject = exports.PlaceSubject = exports.OfficeSubject = exports.FloorMapSubject = exports.FloorSubject = exports.FilterSubject = exports.FileSubject = exports.DeviceSettingsSubject = exports.DeviceSubject = exports.DeliverySubject = exports.DelegatedAccessSubject = exports.DepartmentSubject = exports.CompanySettingsSubject = exports.CompanyIntegrationSubject = exports.CompanySubject = exports.BuildingSubject = exports.PersonalBookingSubject = exports.BookingSubject = exports.BillingSubject = exports.AccessSubject = exports.CRUDAction = void 0;
var tslib_1 = require("tslib");
var ability_1 = require("@casl/ability");
var CRUDAction;
(function (CRUDAction) {
    CRUDAction["Create"] = "create";
    CRUDAction["Read"] = "read";
    CRUDAction["Update"] = "update";
    CRUDAction["Delete"] = "delete";
    CRUDAction["Manage"] = "manage";
})(CRUDAction = exports.CRUDAction || (exports.CRUDAction = {}));
var AccessSubject;
(function (AccessSubject) {
    AccessSubject["BILLING"] = "Billing";
    AccessSubject["BOOKING"] = "Booking";
    AccessSubject["BUILDING"] = "Building";
    AccessSubject["COMPANY"] = "Company";
    AccessSubject["COMPANY_INTEGRATION"] = "CompanyIntegration";
    AccessSubject["COMPANY_SETTINGS"] = "CompanySettings";
    AccessSubject["DELEGATED_ACCESS"] = "DelegatedAccess";
    AccessSubject["DELIVERY"] = "Delivery";
    AccessSubject["DEPARTMENT"] = "Department";
    AccessSubject["DEVICE"] = "Device";
    AccessSubject["DEVICE_SETTINGS"] = "DeviceSettings";
    AccessSubject["FILE"] = "File";
    AccessSubject["FILTER"] = "Filter";
    AccessSubject["FLOOR"] = "Floor";
    AccessSubject["FLOOR_MAP"] = "FloorMap";
    AccessSubject["NOTIFICATION"] = "Notification";
    AccessSubject["NOTIFICATION_PLAN"] = "NotificationPlan";
    AccessSubject["OFFICE"] = "Office";
    AccessSubject["PERSONAL_BOOKING"] = "PersonalBooking";
    AccessSubject["PLACE"] = "Place";
    AccessSubject["STATISTICS"] = "Statistics";
    AccessSubject["TEAM"] = "Team";
    AccessSubject["USER"] = "User";
    AccessSubject["ZONE"] = "Zone";
    AccessSubject["ZONE_TYPE"] = "ZoneType";
    AccessSubject["SUCCESS_MANAGER"] = "SuccessManager";
})(AccessSubject = exports.AccessSubject || (exports.AccessSubject = {}));
/**
 * Forced subjects for CASL queries
 * @see https://casl.js.org/v5/en/guide/conditions-in-depth#checking-logic-in-casl
 * */
var BillingSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.BILLING, tslib_1.__assign({}, data));
};
exports.BillingSubject = BillingSubject;
var BookingSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.BOOKING, tslib_1.__assign({}, data));
};
exports.BookingSubject = BookingSubject;
var PersonalBookingSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.PERSONAL_BOOKING, tslib_1.__assign({}, data));
};
exports.PersonalBookingSubject = PersonalBookingSubject;
var BuildingSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.BUILDING, tslib_1.__assign({}, data));
};
exports.BuildingSubject = BuildingSubject;
var CompanySubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.COMPANY, tslib_1.__assign({}, data));
};
exports.CompanySubject = CompanySubject;
var CompanyIntegrationSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.COMPANY_INTEGRATION, tslib_1.__assign({}, data));
};
exports.CompanyIntegrationSubject = CompanyIntegrationSubject;
var CompanySettingsSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.COMPANY_SETTINGS, tslib_1.__assign({}, data));
};
exports.CompanySettingsSubject = CompanySettingsSubject;
var DepartmentSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.DEPARTMENT, tslib_1.__assign({}, data));
};
exports.DepartmentSubject = DepartmentSubject;
var DelegatedAccessSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.DELEGATED_ACCESS, tslib_1.__assign({}, data));
};
exports.DelegatedAccessSubject = DelegatedAccessSubject;
var DeliverySubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.DELIVERY, tslib_1.__assign({}, data));
};
exports.DeliverySubject = DeliverySubject;
var DeviceSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.DEVICE, tslib_1.__assign({}, data));
};
exports.DeviceSubject = DeviceSubject;
var DeviceSettingsSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.DEVICE_SETTINGS, tslib_1.__assign({}, data));
};
exports.DeviceSettingsSubject = DeviceSettingsSubject;
var FileSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.FILE, tslib_1.__assign({}, data));
};
exports.FileSubject = FileSubject;
var FilterSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.FILTER, tslib_1.__assign({}, data));
};
exports.FilterSubject = FilterSubject;
var FloorSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.FLOOR, tslib_1.__assign({}, data));
};
exports.FloorSubject = FloorSubject;
var FloorMapSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.FLOOR_MAP, tslib_1.__assign({}, data));
};
exports.FloorMapSubject = FloorMapSubject;
var OfficeSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.OFFICE, tslib_1.__assign({}, data));
};
exports.OfficeSubject = OfficeSubject;
var PlaceSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.PLACE, tslib_1.__assign({}, data));
};
exports.PlaceSubject = PlaceSubject;
var StatisticsSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.STATISTICS, tslib_1.__assign({}, data));
};
exports.StatisticsSubject = StatisticsSubject;
var TeamSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.TEAM, tslib_1.__assign({}, data));
};
exports.TeamSubject = TeamSubject;
var UserSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.USER, tslib_1.__assign({}, data));
};
exports.UserSubject = UserSubject;
var ZoneSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.ZONE, tslib_1.__assign({}, data));
};
exports.ZoneSubject = ZoneSubject;
var ZoneTypeSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.ZONE_TYPE, tslib_1.__assign({}, data));
};
exports.ZoneTypeSubject = ZoneTypeSubject;
var NotificationSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.NOTIFICATION, tslib_1.__assign({}, data));
};
exports.NotificationSubject = NotificationSubject;
var NotificationPlanSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.NOTIFICATION_PLAN, tslib_1.__assign({}, data));
};
exports.NotificationPlanSubject = NotificationPlanSubject;
var SuccessManagerSubject = function (data) {
    if (data === void 0) { data = {}; }
    return (0, ability_1.subject)(AccessSubject.SUCCESS_MANAGER, tslib_1.__assign({}, data));
};
exports.SuccessManagerSubject = SuccessManagerSubject;
